import api from '../api/api-list'

const state = {
	templateCvs: [], // 简历模板
	cvList: [], // cv列表
	softDeleteCount: 0, // 已删除简历分数
}

const actions = {
	// 获取template cv
	getTemplateCv: async function ({ commit }) {
		let res = await api.cv.getTemplateCv()
		if (res.code === 1000) {
			commit('changeTemplateCvs', res.data)
		}
	},
	// 获取简历列表
	getCvList: async function ({ commit }, payload) {
		try {
			window.scrollTo(0, 0)
			let res = await api.cv.getCvList(payload)
			if (res.code === 1000) {
				commit('changeCvList', res.data.cvs)
				commit('changeSoftCount', res.data.soft_deleted_cvs_count)
			}
		} catch (e) {
			console.log(e)
		}
	},
}

const getters = {}

const mutations = {
	// 改变模板
	changeTemplateCvs (state, templates) {
		state.templateCvs = templates
	},
	// 改变简历列表
	changeCvList (state, list) {
		state.cvList = list
	},
	// 已删除的简历
	changeSoftCount (state, count) {
		state.softDeleteCount = count
	},
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}
